import { connect } from 'react-redux'
import MapView from '.'
import { addPlacesInfo } from '../../../../actions/neighborhood'

const mapStateToProps = (state, ownProps) => {
  return {
  	
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
  	addPlacesInfo: value => dispatch(addPlacesInfo(value))
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(MapView)


// WEBPACK FOOTER //
// ./src/features/PageNeighborhoods/components/Map/map.js